module.exports = __webpack_public_path__ + "img/osobne_vlastnictvo.ea2b59b4.svg";